import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(VExpandTransition, [
    _setup.doctorDataStore.selectedWorkplace.appointmentRestrictions?.length
      ? _c(
          "div",
          {
            staticClass: "d-flex flex-column",
            attrs: { "data-qa": "appointment_restrictions" },
          },
          [
            _c("div", { staticClass: "d-flex align-center gc-2 mb-2" }, [
              _c("div", { staticClass: "text-h6 text--text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.t("Ограничения", _setup.options)) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass:
                  "ui-icon-error-message ui-icon-fz-medium secondary--text",
              }),
            ]),
            _vm._v(" "),
            _c(VExpandTransition, [
              _c(
                "ul",
                { key: _setup.doctorDataStore.selectedWorkplace.id },
                _vm._l(
                  _setup.doctorDataStore.selectedWorkplace
                    .appointmentRestrictions,
                  function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "text-break",
                        attrs: {
                          "data-qa": "appointment_restrictions_restriction",
                        },
                      },
                      [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                    )
                  }
                ),
                0
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }